import * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P4):Intercom 式橙 toggle(36×20 药丸白点)。role=switch,键盘可用。 */
export interface SwitchProps
	extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
	({ checked, onCheckedChange, className, disabled, ...props }, ref) => (
		<button
			type="button"
			role="switch"
			aria-checked={checked}
			disabled={disabled}
			ref={ref}
			onClick={() => onCheckedChange(!checked)}
			className={cn(
				"relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors duration-150",
				"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-state-focus focus-visible:ring-offset-2 ring-offset-surface-background",
				checked ? "bg-brand-accent" : "bg-surface-border",
				disabled && "cursor-not-allowed opacity-50",
				className,
			)}
			{...props}
		>
			<span
				className={cn(
					"pointer-events-none block h-4 w-4 rounded-full bg-white shadow-sm transition-transform duration-150",
					checked ? "translate-x-[18px]" : "translate-x-0.5",
				)}
			/>
		</button>
	),
);
Switch.displayName = "Switch";

/** P4 开关配置行:toggle 左置 + 粗标题 + 灰说明,项间由父级 divide-y 分隔(不套卡框)。 */
export function SwitchRow({
	checked,
	onCheckedChange,
	title,
	description,
	disabled,
	children,
}: {
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	title: React.ReactNode;
	description?: React.ReactNode;
	disabled?: boolean;
	children?: React.ReactNode;
}) {
	return (
		<div className="flex items-start gap-3 py-4">
			<Switch
				checked={checked}
				onCheckedChange={onCheckedChange}
				disabled={disabled}
				className="mt-0.5"
			/>
			<div className="min-w-0 flex-1 space-y-0.5">
				<div className="text-sm font-semibold text-text-primary">{title}</div>
				{description ? <div className="text-[13px] text-text-secondary">{description}</div> : null}
				{children ? <div className="pt-2">{children}</div> : null}
			</div>
		</div>
	);
}
